export default () => {
	const form = document.querySelector('#newsletter-form');

	if (!form) {
		return;
	}
	const popup = document.querySelector('.js-newsletter-popup');
	const submitBtn = popup.querySelector('.newsletter-form__btn-submit');

    const successMessage = popup.querySelector('.newsletter-popup__success-message');
    const errorMessage = popup.querySelector('.newsletter-popup__error-message');
    const popupInner = popup.querySelector('.newsletter-popup__inner');

    const emailInput = popup.querySelector('#newsletter-email');
	// const dateInput = popup.querySelector('#newsletter-date-of-birth');

    function validateEmail() {
        const email = emailInput.value.trim();
        const field = emailInput.closest('.field');
  
        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  
        if (emailRegex.test(email)) {
            field.classList.remove('is-error');
			return true;
            //submitBtn.disabled = false;
        } else {
            field.classList.add('is-error');
			return false;
            //submitBtn.disabled = true;
        }
    }

	function validateDate(inputDate) {

		if (/^\d{8}$/.test(inputDate)) {
			const day = parseInt(inputDate.substring(0, 2), 10);
			const month = parseInt(inputDate.substring(2, 4), 10);
		
			if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
			  return true; // Valid "DDMMYYYY" format
			}
		}
		
		return false;
	}		 

    function formatDate(inputDate) {
        const day = inputDate.substr(0, 2);
        const month = inputDate.substr(2, 2);
        const year = inputDate.substr(4, 4);

        const date = new Date(year, month - 1, day);
      
        const formattedDate = date.toISOString().split('T')[0];
      
        return formattedDate;
    }

	const onSubmit = async (e) => {

        errorMessage.classList.remove('is-visible');

		e.preventDefault();
		if (!validateEmail()) return;
		submitBtn.disabled = true;

		//const name = popup.querySelector('#newsletter-name').value;
		//const phone = popup.querySelector('#newsletter-phone').value;
		const email = popup.querySelector('#newsletter-email').value;
		/* const dateOfBith = popup.querySelector(
			'#newsletter-date-of-birth',
		).value; */

		const ID = 'WUtT7H';

		const body = new URLSearchParams({
			g: ID,
			//$fields: '$first_name,$phone_number,Birthday',
			//first_name: name,
			email,
			//phone_number: phone,
			//Birthday: formatDate(dateOfBith),
		});

		try {
			const response = await fetch(
				'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
				{
					method: 'POST',
					headers: {
						'content-type': 'application/x-www-form-urlencoded',
						'cache-control': 'no-cache',
					},
					body,
					mode: 'cors',
					credentials: 'same-origin'
				},
			);
            const result = await response.json();

            if(result?.success) {
                successMessage.style.display = 'flex';
                popupInner.style.display = 'none';
				setCookiePopup();
            } else {
                errorMessage.classList.add('is-visible');
            }

		} catch (e) {
			console.error(e);
            errorMessage.classList.add('is-visible');
		} finally {
			submitBtn.disabled = false;
		}
	};

	/* emailInput.addEventListener('input', () => {
        validateEmail();
    }); */

	/* dateInput.addEventListener('blur', () => {
		const field = dateInput.closest('.field');

		if (validateDate(dateInput.value)) {
			field.classList.remove('is-error');
            submitBtn.disabled = false;
		} else {
			field.classList.add('is-error');
            submitBtn.disabled = true;
		}
    }); */

	form.addEventListener('submit', onSubmit);
};

export function setCookiePopup(type) {
	let expirationDate = new Date();

	if(type === 'close') {
		expirationDate = new Date(expirationDate.getTime() + 30 * 24 * 60 * 60 * 1000);

	} else {
		expirationDate.setFullYear(expirationDate.getFullYear() + 1);
	}

	const expires = expirationDate.toUTCString();

	document.cookie = "issubscribed=true; expires=" + expires + "; path=/";
}
